import { useAppSelector } from '@/hooks';
import { Icons } from '@/utils/Icons';
import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Footer = () => {
  const [quickLinksOpen, setQuickLinksOpen] = useState(false);
  const [rulesOpen, setRulesOpen] = useState(false);
  const { supportInfo } = useAppSelector((state) => state.user);
  return (
    <footer className="text-white py-10 max-lg:pb-[90px]">
      {/* Top Section */}
      <div className="grid lg:grid-cols-2 gap-4 mb-[14px]">
        {/* Support Card */}
        <div className="p-4 rounded-2xl bg-[#1c1d25] text-white flex max-md:flex-col justify-between md:items-center overflow-hidden relative">
          <div className="w-[150px] flex flex-col gap-1">
            <div className="px-2 text-primary text-sm">
              Support
              <span className="inline-block bg-primary text-white text-[12px] font-bold px-2 py-[2px] rounded-xl ml-[6px]">
                24/7
              </span>
            </div>

            <p className="px-2 py-1 text-[12px]">Contact us if you still have questions</p>
          </div>

          {/* Background Glow */}
          <div className="w-full md:w-[91px] h-full relative">
            <div className="absolute left-1/2 top-0 w-[400%] h-[calc(100%+32px)] -translate-x-1/2 -translate-y-[16px] after:content-[''] after:absolute after:w-[200%] after:h-[400%] after:md:bg-[radial-gradient(circle,#ffc600_0%,rgba(0,215,109,0)_50%)] after:top-0 after:left-1/2 after:-translate-x-1/2 after:z-[1] after:opacity-50" />

            <img
              src="/images/support.png"
              alt="support"
              className="absolute w-[91px] bottom-0 right-0 translate-y-[16px]"
            />
          </div>

          <Link
            to={supportInfo?.whatsapp ?? '#'}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => !supportInfo?.whatsapp && e.preventDefault()}
            className="text-center bg-primary hover:bg-yellow-400 text-white px-[10px] py-[5px] rounded-lg font-semibold z-[1]"
          >
            Contact Support
          </Link>
        </div>

        {/* Right Container */}
        <div className="grid md:grid-cols-3 gap-3">
          <div className="md:col-span-2">
            <div className="h-full p-4 rounded-2xl bg-[var(--primary-dark-color)] text-[var(--black-white)]">
              <div className="font-bold px-2 text-[14px] text-[var(--profileText)]">
                100% Safe & instant payments
              </div>

              <div className="flex flex-col px-2 py-1 text-[12px] gap-[5px] w-full">
                <p className="text-justify">
                  You can make payments and receive earnings instantly using your UPI ID or bank
                  account details, ensuring your money is always safe and secure. All major UPI
                  platforms are supported.
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-1">
            <div className="h-full p-4 rounded-2xl bg-[var(--primary-dark-color)] text-[var(--black-white)]">
              <div className="font-bold px-2 text-[14px] text-[var(--profileText)]">Contact Us</div>

              <div className="flex flex-col px-2 py-1 text-[12px] gap-[5px] w-full">
                <span className="text-center text-[var(--header-txt-color)] text-[12px] font-semibold leading-[20px] tracking-[0.3px]">
                  {supportInfo?.whatsapp ? '+' + supportInfo?.whatsapp?.split('me/')?.[1] : ' '}
                </span>

                <span className="text-center text-[var(--header-txt-color)] text-[12px] font-semibold leading-[20px] tracking-[0.3px]">
                  support@ultrabet777.com
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Links Section */}
      <div className="flex max-lg:flex-col gap-y-[14px] gap-x-10 mb-10">
        {/* Quick Links */}
        <div className="max-lg:bg-[#1C1D25] rounded-2xl max-lg:px-[22px] max-lg:p-4">
          <h4 className="text-primary font-bold flex items-center justify-between">
            <span>Quick Link</span>
            <Icons.Down
              className={`lg:hidden transition-all ease-in-out duration-300 ${quickLinksOpen ? 'rotate-180' : ''}`}
              onClick={() => setQuickLinksOpen(!quickLinksOpen)}
            />
          </h4>

          <div
            className={`${
              quickLinksOpen ? 'grid' : 'hidden'
            } lg:grid grid-cols-2 gap-2 text-[10px] text-[#cbcbcb
] lg:w-[250px]`}
          >
            <NavLink to="/sports">Sports</NavLink>
            <NavLink to="/casino">Casino</NavLink>
            <NavLink to="/sport/cricket">Cricket</NavLink>
            <NavLink to={'#'}>Teen Patti</NavLink>
            <NavLink to={'#'}>Andar Bahar</NavLink>
            <NavLink to={'#'}>Roulette</NavLink>
            <NavLink to={'#'}>Live Betting</NavLink>
            <NavLink to={'/deposit'}>Deposit</NavLink>
            <NavLink to={'/withdraw'}>Withdraw</NavLink>
          </div>
        </div>

        {/* Info (Rules Toggle) */}
        <div className="max-lg:bg-[#1C1D25] rounded-2xl max-lg:px-[22px] max-lg:p-4">
          <h4 className="text-primary font-bold flex items-center justify-between">
            <span>Info</span>
            <Icons.Down
              className={`lg:hidden transition-all ease-in-out duration-300 ${rulesOpen ? 'rotate-180' : ''}`}
              onClick={() => setRulesOpen(!rulesOpen)}
            />
          </h4>

          <div className={`${rulesOpen ? 'block' : 'hidden'} lg:block text-[#cbcbcb] text-[10px]`}>
            <a
              href="/rules"
              target="rulesPopup"
              onClick={(e) => {
                e.preventDefault();

                window.open(
                  '/rules',
                  'rulesPopup',
                  'width=1200,height=800,scrollbars=yes,resizable=yes'
                );
              }}
            >
              Rules
            </a>
          </div>
        </div>
      </div>

      {/* Social + Payments */}
      <div className="flex flex-col lg:flex-row items-center justify-between gap-6 mb-6">
        <div className="flex gap-3 flex-wrap justify-center">
          <img src="/icons/social-icons/facebook.svg" alt="facebook" />

          <img src="/icons/social-icons/x.svg" alt="x" />

          <img src="/icons/social-icons/instagram.svg" alt="instagram" />

          <img src="/icons/social-icons/youtube.svg" alt="youtube" />

          <img src="/icons/social-icons/linkedin.svg" alt="linkedin" />

          <Link
            to={supportInfo?.telegram ?? '#'}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => !supportInfo?.telegram && e.preventDefault()}
          >
            <img src="/icons/social-icons/telegram.svg" alt="telegram" />
          </Link>

          <img src="/icons/social-icons/discord.svg" alt="discord" />

          <Link
            to={supportInfo?.whatsapp ?? '#'}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => !supportInfo?.whatsapp && e.preventDefault()}
          >
            <img src="/icons/social-icons/whatsapp.svg" alt="whatsapp" />
          </Link>

          <img src="/icons/social-icons/pinterest.svg" alt="pinterest" />

          <img src="/icons/social-icons/gmail.svg" alt="gmail" />
        </div>

        <div className="flex gap-4 items-center">
          {['upi', 'phonepe', 'gpay', 'bank', 'paytm', 'visa', 'mastercard'].map((item, i) => (
            <img
              key={i}
              src={`/icons/payments/${item}.svg`}
              alt={item}
              className="h-6 object-contain"
            />
          ))}
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-700 my-6"></div>

      {/* Certifications */}
      <div className="flex flex-wrap justify-center gap-6 mb-6">
        {['18plus', 'gamecare', 'gt', 'rng', 'gc', 'gr', 'rfg'].map((item, i) => (
          <img
            key={i}
            src={`/icons/footer/${item}.svg`}
            alt={item}
            className="h-10 object-contain"
          />
        ))}
      </div>

      <div className="w-full h-px bg-gray-300/30 my-[14px]"></div>

      {/* Bottom Text */}
      <div className="text-[10px] leading-[15px] font-medium">
        <p>
          ultrabet777.com is Asia's one of the biggest gaming platforms with over 350 games and
          sports available. Popular sports such as Cricket, Tennis, Football, Basketball, Volleyball
          and many more including Indian card games like Teen Patti and Andar Bahar are also
          available. With unlimited markets and odds, ultrabet777.com gives players the best gaming
          experience in the market.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
